<div class="flex-1 flex items-center justify-center p-6">
  <mat-card
    class="max-w-xl w-full rounded-3xl shadow-2xl overflow-hidden border border-neutral-3 transition-all hover:shadow-primary-a3"
  >
    <div class="p-10">
      @if (status() === Status.REVIEW_REQUIRED) {
        <div class="text-center">
          <div
            class="w-20 h-20 bg-blue-9 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-blue-a4"
          >
            <mat-icon class="text-white !text-[40px] !w-10 !h-10">fact_check</mat-icon>
          </div>
          <h1 class="text-4xl font-extrabold text-neutral-12 mb-4 tracking-tight">
            Vérification en cours...
          </h1>
          <p class="text-lg text-neutral-11 mb-6 leading-relaxed">
            Stripe a validé l'authenticité de votre document !
          </p>

          <div
            class="bg-amber-2 border border-amber-5 rounded-2xl p-6 mb-8 text-left animate-in fade-in slide-in-from-top-2 duration-500"
          >
            <h3 class="font-bold text-amber-11 mb-2 flex items-center gap-2">
              <mat-icon class="!w-5 !h-5 !text-[20px]">warning</mat-icon>
              Action admin requise : Vérification manuelle
            </h3>
            <p class="text-sm text-amber-11 leading-relaxed mb-4">
              Nous avons détecté une différence entre les informations de votre document et celles de votre
              profil
            </p>

            @if (identityStatus()?.stripeIdentity?.firstName && identityStatus()?.stripeIdentity?.lastName) {
              <div class="grid grid-cols-2 gap-4">
                <div class="space-y-2">
                  <p class="text-neutral-10 uppercase font-bold">Votre profil</p>
                  <div class="bg-white/50 rounded-xl border border-amber-2">
                    <p class="font-semibold text-neutral-12">
                      {{ identityStatus()?.userIdentity?.firstName }}
                      {{ identityStatus()?.userIdentity?.lastName }}
                    </p>
                  </div>
                </div>
                <div class="space-y-2">
                  <p class="text-neutral-10 uppercase font-bold">Pièce d'identité</p>
                  <div class="bg-white/50 rounded-xl border border-amber-2">
                    <p class="font-semibold text-neutral-12">
                      {{ identityStatus()?.stripeIdentity?.firstName }}
                      {{ identityStatus()?.stripeIdentity?.lastName }}
                    </p>
                  </div>
                </div>
              </div>
            }

            <p class="mt-4 text-sm text-amber-11">
              Un administrateur doit valider manuellement cette cohérence (délai de 24h ouvrées maximum). Vous
              recevrez une notification dès que la vérification sera effectuée.
            </p>
          </div>

          <button
            mat-flat-button
            class="primary w-full !py-8 !text-lg !font-bold shadow-xl"
            [disabled]="true"
          >
            {{ successActionLabel() }}
          </button>
        </div>
      } @else if (status() === Status.VERIFIED) {
        <div class="text-center">
          <div
            class="w-20 h-20 bg-green-9 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-green-a4"
          >
            <mat-icon class="text-white !text-[40px] !w-10 !h-10">verified</mat-icon>
          </div>
          <h1 class="text-4xl font-extrabold text-neutral-12 mb-4 tracking-tight">Identité vérifiée !</h1>
          <p class="text-lg text-neutral-11 mb-10 leading-relaxed">
            {{ successMessage() }}
          </p>
          <button
            mat-flat-button
            class="primary w-full !py-8 !text-lg !font-bold shadow-xl"
            (click)="continued.emit()"
          >
            {{ successActionLabel() }}
          </button>
        </div>
      } @else if (status() === Status.PROCESSING) {
        <div class="text-center">
          <div
            class="w-20 h-20 bg-amber-9 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-amber-a4 animate-pulse"
          >
            <mat-icon class="text-white !text-[40px] !w-10 !h-10">hourglass_empty</mat-icon>
          </div>
          <h1 class="text-4xl font-extrabold text-neutral-12 mb-4 tracking-tight">
            Vérification en cours...
          </h1>
          <p class="text-lg text-neutral-11 mb-10 leading-relaxed">
            Stripe analyse actuellement vos documents. Cela prend généralement quelques minutes. Nous vous
            informerons dès que le processus sera terminé.
          </p>
          <button
            mat-stroked-button
            class="w-full !py-8 !text-lg !font-bold transition-all duration-300"
            (click)="refreshUser()"
            [disabled]="isRefreshing() || refreshCooldown() > 0"
          >
            @if (isRefreshing()) {
              <div class="flex items-center justify-center gap-3">
                <mat-icon class="animate-spin !w-6 !h-6 !text-[24px]">refresh</mat-icon>
                <span>Actualisation...</span>
              </div>
            } @else if (refreshCooldown() > 0) {
              <div class="flex items-center justify-center gap-3">
                <mat-icon class="!w-6 !h-6 !text-[24px]">timer</mat-icon>
                <span>Réessayer dans {{ refreshCooldown() }}s</span>
              </div>
            } @else {
              Actualiser le statut
            }
          </button>

          @if (canRestartVerification()) {
            <div class="mt-6 pt-6 border-t border-neutral-3">
              <p class="text-sm text-neutral-10 mb-4 leading-relaxed">
                La vérification semble prendre plus de temps que prévu. Si vous pensez qu'il y a eu un
                problème, vous pouvez tenter de relancer le processus.
              </p>
              <button
                mat-button
                color="primary"
                class="w-full !py-6 !text-base !font-semibold transition-all hover:bg-primary-a1"
                (click)="onVerifyIdentity()"
                [disabled]="isRefreshing()"
              >
                <mat-icon class="mr-2">restart_alt</mat-icon>
                Lancer une nouvelle vérification
              </button>
            </div>
          }
        </div>
      } @else {
        <div
          class="w-16 h-16 bg-primary-9 rounded-2xl flex items-center justify-center mb-8 shadow-lg shadow-primary-a4"
        >
          <mat-icon class="text-white">verified_user</mat-icon>
        </div>

        <h1 class="text-4xl font-extrabold text-neutral-12 mb-4 tracking-tight">{{ title() }}</h1>
        <p class="text-lg text-neutral-11 mb-10 leading-relaxed">
          {{ description() }}
        </p>

        <div class="space-y-6 mb-10">
          <div
            class="flex items-start gap-4 p-5 rounded-2xl bg-neutral-2 border border-neutral-3 transition-colors hover:bg-neutral-3"
          >
            <div class="mt-1">
              <div class="w-2 h-2 rounded-full bg-primary-9"></div>
            </div>
            <div>
              <h3 class="font-bold text-neutral-12 mb-1">Scanner votre document</h3>
              <p class="text-sm text-neutral-11">
                Munissez-vous de votre CNI ou de votre passeport en cours de validité.
              </p>
            </div>
          </div>

          <div
            class="flex items-start gap-4 p-5 rounded-2xl bg-neutral-2 border border-neutral-3 transition-colors hover:bg-neutral-3"
          >
            <div class="mt-1">
              <div class="w-2 h-2 rounded-full bg-primary-9"></div>
            </div>
            <div>
              <h3 class="font-bold text-neutral-12 mb-1">Prendre un selfie</h3>
              <p class="text-sm text-neutral-11">
                Pour confirmer que vous êtes bien le titulaire du document.
              </p>
            </div>
          </div>
        </div>

        @if (lastSession(); as session) {
          <div
            class="mb-10 p-5 rounded-2xl border flex items-start gap-4 animate-in fade-in slide-in-from-top-4 duration-500 shadow-xs"
            [class]="
              session.conciliation === ConciliationStatus.FAILED || session.status === Status.FAILED
                ? 'bg-ruby-2 border-ruby-5 text-ruby-12'
                : 'bg-amber-2 border-amber-5 text-amber-12'
            "
          >
            <mat-icon
              class="shrink-0 mt-0.5 !w-7 !h-7 !text-[28px]"
              [class]="
                session.conciliation === ConciliationStatus.FAILED || session.status === Status.FAILED
                  ? 'text-ruby-9'
                  : 'text-amber-9'
              "
            >
              {{
                session.conciliation === ConciliationStatus.FAILED || session.status === Status.FAILED
                  ? 'error_outline'
                  : 'history'
              }}
            </mat-icon>
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between gap-2 mb-1 flex-wrap">
                <h3 class="font-bold text-sm">Dernière tentative de vérification</h3>
                @if (session.createdAt) {
                  <span class="text-xs text-neutral-10">
                    {{ session.createdAt | date: 'dd/MM/yyyy à HH:mm' }}
                  </span>
                }
              </div>
              <p class="text-xs leading-relaxed text-neutral-11">
                @if (session.conciliation === ConciliationStatus.FAILED) {
                  La précédente vérification n'a pas pu être validée car les informations de votre pièce
                  d'identité ne correspondaient pas exactement à votre profil. Vous pouvez corriger votre
                  profil ou relancer une vérification.
                } @else if (session.status === Status.FAILED) {
                  Désolé, la vérification n'a pas pu aboutir ou a été annulée. Veuillez réessayer avec des
                  documents lisibles et un bon éclairage.
                } @else {
                  La précédente vérification n'a pas abouti à une validation. Vous pouvez relancer une
                  nouvelle tentative à tout moment.
                }
              </p>
            </div>
          </div>
        }

        <button
          mat-flat-button
          class="primary w-full !py-8 !text-lg !font-bold transition-all duration-300 transform hover:-translate-y-1 active:scale-95 shadow-xl"
          (click)="onVerifyIdentity()"
        >
          {{ lastSession() ? 'Réessayer la vérification' : 'Lancer la vérification' }}
          <mat-icon iconPositionEnd>{{ lastSession() ? 'refresh' : 'arrow_forward' }}</mat-icon>
        </button>

        <p class="mt-6 text-center text-xs text-neutral-10 font-medium">
          Propulsé par <span class="text-neutral-12 font-bold">Stripe Identity</span>. Aucune image n'est
          stockée par ETXE.
        </p>
      }
    </div>
  </mat-card>
</div>
